import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

export const WashingMachine = ({fill="#55b336", className}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={classNames(styles.icon,className)} viewBox="0 0 107.999 107.999">
    <g transform="translate(-145 -130)">
      <path
            d="M101.249,0H6.75A6.75,6.75,0,0,0,0,6.75V23.625a2.25,2.25,0,0,0,2.25,2.25H24.228a1.013,1.013,0,0,0,.562-.189,52.829,52.829,0,0,1,58.423,0,1,1,0,0,0,.558.189h21.978a2.25,2.25,0,0,0,2.25-2.25V6.75A6.75,6.75,0,0,0,101.249,0ZM79.874,16.875A3.375,3.375,0,1,1,83.249,13.5,3.375,3.375,0,0,1,79.874,16.875Zm13.5,0A3.375,3.375,0,1,1,96.749,13.5,3.375,3.375,0,0,1,93.374,16.875Z"
            transform="translate(145 130)"
            fill={fill}/>
      <path
            d="M105.749,14.136H83.771a7.722,7.722,0,0,1-4.306-1.327,46.835,46.835,0,0,0-50.926,0,7.744,7.744,0,0,1-4.311,1.327H2.25A2.25,2.25,0,0,0,0,16.386V82.76a6.75,6.75,0,0,0,6.75,6.75h94.5A6.75,6.75,0,0,0,108,82.76V16.386A2.25,2.25,0,0,0,105.749,14.136ZM54,76.011a29.25,29.25,0,1,1,29.25-29.25A29.25,29.25,0,0,1,54,76.011Z"
            transform="translate(145 148.488)"
            fill={fill}/>
      <path
            d="M27.75,10A20.25,20.25,0,1,0,48,30.25,20.25,20.25,0,0,0,27.75,10Zm0,31.5A11.25,11.25,0,1,1,39,30.25,11.25,11.25,0,0,1,27.75,41.5Z"
            transform="translate(171.25 165)" 
            fill={fill}/>
    </g>
  </svg>
);
